<template>
	<div>

		<v-data-table
			:headers="encabezado"
			:items="fuente.listado"
			item-key="identificador"
			class="elevation-1 mb-16"
			:items-per-page="10000"
			:loading="fuente.listando"
			hide-default-footer
		>
			<template v-slot:item.acciones="{ item }">
				<v-btn icon @click="abrirEdición(item)">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</template>
		</v-data-table>

		<v-dialog
      v-model="diálogo"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Usuario</v-card-title>

        <v-card-text>

					<v-text-field
						v-model="datos.nombres"
						maxlength="50"
						label="Nombres"
						required
					></v-text-field>

					<v-text-field
						v-model="datos.apellidos"
						maxlength="50"
						label="Apellidos"
						required
					></v-text-field>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
						:disabled="fuente.guardando"
            @click="cerrarDiálogo()"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
						:loading="fuente.guardando"
            @click="guardar"
					>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<!--<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="abrirCreación()"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>-->

	</div>
</template>

<script>
import { usuarios } from '@/../../cliente_comun/fuentes'

export default {
	name: 'Usuarios',
  data: () => ({
		fuente: usuarios,
		diálogo: false,
		datos: {
			identificador: '',
			nombres: '',
			apellidos: '',
		},
		encabezado: [
			{ text: 'Nombres', value: 'nombres', sortable: false },
			{ text: 'Apellidos', value: 'apellidos', sortable: false },
			{ text: '', value: 'acciones' }
		]
	}),
	mounted: function() {
		this.fuente.inicializar()
	},
	methods: {
		guardar: function() {
			this.fuente.guardar(this.datos, this.datos.identificador).then( () => {
				this.cerrarDiálogo()
			})
		},
		cerrarDiálogo: function() {
			this.diálogo = false
			this.limpiar()
		},
		abrirEdición: function(el) {
			this.datos.identificador = el.identificador
			this.datos.nombres = el.nombres
			this.datos.apellidos = el.apellidos
			this.diálogo = true
		},
		abrirCreación: function() {
			this.limpiar()
			this.diálogo = true
		},
		limpiar: function() {
			this.datos.identificador = ''
			this.datos.nombres = ''
			this.datos.apellidos = ''
		}
	}
}
</script>